import { useContext } from "react";
import { ActivitiesContext } from "../../context/activities-context";

const ExtraFilter = () => {
	const {
		extraButtonActive,
		setExtraButtonActive,
		extraButtonId,
		setExtraButtonId,
		setActivityString,
		dictionaryWords,
	} = useContext(ActivitiesContext);

	const extraFilterHandler = (event) => {
		if (extraButtonId === "") {
			setActivityString(event.target.value);
			setExtraButtonId(event.target.id);
			setExtraButtonActive(true);
		} else if (extraButtonId !== event.target.id) {
			setActivityString(event.target.value);
			setExtraButtonId(event.target.id);
			setExtraButtonActive(true);
		} else if (extraButtonId === event.target.id) {
			setActivityString('AND terms.label:"Kamp of vakantie"');
			setExtraButtonId("");
			setExtraButtonActive(false);
		}
	};

	return (
		<div className="filter-section">
			<h3>{dictionaryWords.extra}</h3>
			<div>
				<button
					id="zonder_overnachting"
					value='AND terms.label:"Kamp of vakantie" AND labels:(Zonder overnachting)'
					onClick={extraFilterHandler}
					className={
						extraButtonActive &&
						extraButtonId === "zonder_overnachting"
							? "active"
							: ""
					}
				>
					{dictionaryWords.noStayOvernight}
					<i className="fa fa-close"></i>
				</button>
				<button
					id="met_overnachting"
					value='AND terms.label:"Kamp of vakantie" AND labels:(Met overnachting)'
					onClick={extraFilterHandler}
					className={
						extraButtonActive &&
						extraButtonId === "met_overnachting"
							? "active"
							: ""
					}
				>
					{dictionaryWords.stayOvernight}
					<i className="fa fa-close"></i>
				</button>
			</div>
		</div>
	);
};

export default ExtraFilter;
